/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import BurgerMenu from 'react-burger-menu/lib/menus/slide';
import cx from 'classnames';
import styles from './SidebarLayout.scss';
import EdroloLogo from '../EdroloLogo';

const SidebarWrapper = ({ children }) => (
  <div className={styles.sidebarWrapper}>{children}</div>
);

const mql = window.matchMedia(`(min-width: 1180px)`);

class SidebarLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDocked: mql.matches,
      sidebarOpen: false,
    };
  }

  componentDidMount() {
    mql.addListener(this.mediaQueryChanged);
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged);
  }

  onSetSidebarOpen = (open) => {
    global.analytics.track(`${open ? 'opened' : 'closed'} sidebar`, {
      origin: this.props.trackingOrigin,
      ...this.props.analyticsPayload,
    });
    this.setState({ sidebarOpen: open });
  };

  mediaQueryChanged = () => {
    this.setState({ isDocked: mql.matches, sidebarOpen: false });
  };

  closeSidebar = () => {
    this.setState({ sidebarOpen: false });
  };

  renderDocked() {
    const { renderSidebar, sidebarClassName, children, trackingOrigin } =
      this.props;
    return (
      <div className={styles.sidebarLayout}>
        <div className={cx(styles.sidebar, sidebarClassName)}>
          <SidebarWrapper>
            <div className={styles.logoContainer}>
              <EdroloLogo trackingOrigin={trackingOrigin} />
            </div>
            {renderSidebar(this.closeSidebar, this.state.isDocked)}
          </SidebarWrapper>
        </div>
        <div className={styles.mainContent}>{children}</div>
      </div>
    );
  }

  renderBurger() {
    /*  div structure for this layout needs to match the container layout
        to avoid remounting
    */
    const { children, renderSidebar } = this.props;
    return (
      <div>
        <BurgerMenu
          width="280px"
          isOpen={this.state.sidebarOpen}
          onStateChange={({ isOpen }) => this.onSetSidebarOpen(isOpen)}
          burgerButtonClassName={styles.burgerButton}
          burgerBarClassName={styles.burgerBar}
          crossButtonClassName={styles.crossButton}
          crossClassName={styles.cross}
          menuClassName={styles.menu}
          morphShapeClassName={styles.morphShape}
          itemListClassName={styles.itemList}
          itemClassName={styles.item}
          overlayClassName={styles.overlay}
        >
          {renderSidebar(this.closeSidebar)}
        </BurgerMenu>
        <div>{children}</div>
      </div>
    );
  }

  render() {
    const { isDocked } = this.state;
    return isDocked ? this.renderDocked() : this.renderBurger();
  }
}

export default SidebarLayout;
